import PropTypes from "prop-types"
import { connect } from "react-redux"

const InternalHeading = ({ showStep, isDiamond, currentStepName }) => {
  if (["confirm_gemstone", "final_diamond"].includes(currentStepName)) {
    return null
  }
  const stepTitle = {
    choose_gemstone: "Gemstone",
    choose_stone_type: "Stone Type",
    d_carat: isDiamond ? "Stone Weight" : "Stone Size",
    d_shape: "Stone Shape",
  }
  return (
    <h4
      className="text-18 mb-8 flex items-center text-black"
      id={`diamond-selector-${currentStepName}`}
    >
      <div className="text-18 mr-8 h-24 w-24 rounded-full border-2 border-black text-center">
        {showStep + 1}
      </div>{" "}
      Choose Your {stepTitle[currentStepName] || "Quality"}
    </h4>
  )
}

const mapStateToProps = (state) => {
  const currentStepIndex = state.diamondUI.currentStep
  const maxStep = state.diamondUI.steps.includes("choose_stone_type") ? 3 : 2
  const isDiamond = state.choices.d_stone_type?.value?.includes("DIAM")
  return {
    currentStepName: state.diamondUI.steps[currentStepIndex],
    isDiamond,
    showStep: Math.min(state.diamondUI.currentStep, maxStep),
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalHeading.propTypes = {
  currentStepName: PropTypes.string,
  isDiamond: PropTypes.bool,
  showStep: PropTypes.number,
}

const Heading = connect(mapStateToProps, mapDispatchToProps)(InternalHeading)

export default Heading
